import { Card, Grid, List, ListItem, ListItemSecondaryAction, ListItemText, ListSubheader, Typography } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from "react-redux";
import { DateFnsFormats, formatAs } from '../../../../common-client2/src/services/ukgDateTime';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';

const StyleListItemText = withStyles({
    root: {
        fontFamily: 'Roboto',
        maxWidth: '70%',
    },
    primary: {
        fontSize: '14px',
    },
    secondary: {
        fontSize: '12px',
    },
})(ListItemText)

const StyleTypography = withStyles({
    body1: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '14px',
    }
})(Typography)

const mapStateToProps = state => {
    return {
        statusDictionary: state.statusDictionary
    };
};

export default connect(mapStateToProps)(function NotificationList(props) {
    const { 
        managerSettingNames, 
        list, 
        handleViewButton, 
        handleDismissButton, 
        handleDismissAllButton, 
        privateOffersSummary, 
        handleLoadMoreButton 
    } = props;

    const { t } = useTranslation('employmentBillboard', {keyPrefix: 'dialog.notification'});

    // State for confirmation dialog
    const [confirmDialog, setConfirmDialog] = useState({
        open: false,
        offerId: null,
        proposalId: null,
        isVTO: false,
        isDismissAll: false
    });

    const handleDismissClick = (offerId, proposalId, isVTO) => {
        setConfirmDialog({
            open: true,
            offerId,
            proposalId,
            isVTO,
            isDismissAll: false
        });
    };

    const handleDismissAllClick = () => {
        setConfirmDialog({
            open: true,
            offerId: null,
            proposalId: null,
            isVTO: false,
            isDismissAll: true
        });
    };

    const handleConfirmDismiss = () => {
        if (confirmDialog.isDismissAll) {
            handleDismissAllButton();
        } else {
            handleDismissButton(confirmDialog.offerId, confirmDialog.proposalId, confirmDialog.isVTO);
        }
        setConfirmDialog({ open: false, offerId: null, proposalId: null, isVTO: false, isDismissAll: false });
    };

    const handleCancelDismiss = () => {
        setConfirmDialog({ open: false, offerId: null, proposalId: null, isVTO: false, isDismissAll: false });
    };

    const renderListItemContent = (ele) => {
        if (ele.requestType !== 3) {
            return <StyleListItemText primary={
                <StyleTypography>
                    {
                        ele.isNew === true || ele.isNew > 0 ?
                            <Badge style={{ margin: '12px' }} color="secondary" badgeContent={ele.isNew === true ? 1 : ele.isNew}></Badge>
                            : null
                    }
                    <span style={{ fontWeight: 'bold' }}>{ele.employeeName} </span>
                    <span>{ele.statusDisplay} </span>
                    <span style={{ textDecoration: 'underline' }}> {managerSettingNames[ele.managerSettingId]}</span>
                    <div style={{ fontSize: '13px' }}> {"For " + ele.shiftsDates}</div>
                </StyleTypography>
            } secondary={"Submitted on " + formatAs(ele.notificationDate, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)
            } />
        } else {
            return <StyleListItemText primary={
                <StyleTypography>
                    {
                        ele.isNew ?
                            <Badge style={{ margin: '12px' }} color="secondary" badgeContent={1}></Badge>
                            : null
                    }
                    <span>New VTO Signup </span>
                    <span style={{ textDecoration: 'underline' }}> {managerSettingNames[ele.managerSettingId]}</span>
                    <div style={{ fontSize: '13px' }}> {`Request period: ${ele.shiftsDates}`}</div>
                </StyleTypography>
            } secondary={`Submission period: ${ele.notificationDate}`} />
        }
    }

    return (
        <React.Fragment>
            <List style={{ minWidth: '25vw', maxHeight: 'calc(100% - 57px)', overflow: 'auto', padding: 0 }}>
                <ListSubheader component="div" id="nested-list-subheader" style={{ backgroundColor: '#FFFFFF' }}>
                    <Grid container>
                        <Grid item md={6}></Grid>
                        <Grid item justifyContent="flex-end" container md={6}>
                            <Button onClick={handleDismissAllClick}>Dismiss All</Button>
                        </Grid>
                    </Grid>
                </ListSubheader>
                {
                    list.map((ele) => {
                        return (
                            <ListItem dense={true}>
                                <Card style={{ position: 'relative', width: '100%', padding: 5 }}>
                                    {renderListItemContent(ele)}
                                    <ListItemSecondaryAction >
                                        <Button onClick={() => handleViewButton(ele.offerId, ele.proposalId, ele.isOwnOffer)}>View</Button>
                                        <Button onClick={() => handleDismissClick(ele.offerId, ele.proposalId, (+ele.requestType) === 3)}>Dismiss</Button>
                                    </ListItemSecondaryAction>
                                </Card>
                            </ListItem>
                        )
                    })
                }
                {
                    privateOffersSummary && privateOffersSummary.offerIds.length !== privateOffersSummary.loadedIds.length ?
                        <ListItem dense={true}>
                            <Card style={{ position: 'relative', width: '100%', padding: 5 }}>
                                <Button style={{ width: '100%' }} onClick={() => handleLoadMoreButton()}>Load more</Button>
                            </Card>
                        </ListItem>
                        :
                        null
                }

            </List>

            <ConfirmDialog
                title={confirmDialog.isDismissAll ? t('titleDismissAll') : t('titleDismiss')}
                header={confirmDialog.isDismissAll ?  t('headerDismissAll') : t('headerDismiss')}
                showTextField={false}
                open={confirmDialog.open}
                onCancel={handleCancelDismiss}
                onConfirm={handleConfirmDismiss}
            />
        </React.Fragment>
    );
})